import { initModal } from "./bananau-modal.js";

export function initBottiglieSlider() {
	const sliderEl = document.getElementById("bottiglie-splide");
	const detailEl = document.getElementById("bottiglie-detail");
	const detailSplideEl = document.getElementById("bottiglie-detail-splide");
	const openBtns = document.querySelectorAll(".bottiglia-slide__cta");

	if (!sliderEl || !detailEl || !detailSplideEl) return;

	const SVG_NEXT = `<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.4844 10.7744L0.000946045 10.7754" stroke="#705228" stroke-width="0.666667"/>
        <path d="M14.9737 0.235351L25.5137 10.7754L14.9737 21.3153" stroke="#705228" stroke-width="0.666667"/>
    </svg>`;

	// ─── Splide esterno ───────────────────────────────────────────────────
	const sliderSplide = new Splide(sliderEl, {
		type: "slide",
		autoWidth: true,
		focus: "center",
		arrows: false,
		pagination: false,
		mediaQuery: "min",
	});

	sliderSplide.on("overflow", (isOverflow) => {
		sliderSplide.options = {
			arrows: isOverflow,
			focus: isOverflow ? "center" : false,
		};
	});

	sliderSplide.on("arrows:mounted", (prev, next) => {
		prev.innerHTML = SVG_NEXT;
		next.innerHTML = SVG_NEXT;
	});

	sliderSplide.mount();

	// ─── Splide detail ────────────────────────────────────────────────────
	const detailSplide = new Splide(detailSplideEl, {
		type: "loop",
		arrows: true,
		pagination: false,
		drag: true,
	});

	detailSplide.on("arrows:mounted", (prev, next) => {
		prev.innerHTML = SVG_NEXT;
		next.innerHTML = SVG_NEXT;
	});

	detailSplide.mount();

	// ─── Apertura ─────────────────────────────────────────────────────────
	openBtns.forEach((btn) => {
		btn.addEventListener("click", () => {
			const index = parseInt(btn.dataset.index, 10);
			detailEl.hidden = false;
			document.body.classList.add("bottiglie-detail-open");
			document.body.style.overflow = "hidden"; // ← aggiunto
			if (!isNaN(index)) {
				requestAnimationFrame(() => {
					detailSplide.refresh();
					detailSplide.go(index);
				});
			}
		});
	});

	// ─── Chiusura (event delegation) ──────────────────────────────────────
	detailEl.addEventListener("click", (e) => {
		if (e.target.closest(".bottiglie-detail__close")) {
			detailEl.hidden = true;
			document.body.classList.remove("bottiglie-detail-open");
			document.body.style.overflow = ""; // ← aggiunto
		}
	});

	// ─── Init modal ───────────────────────────────────────────────────────
	initModal();
}
